export const enum SelectedMenu {
  BUY_HARDWARE = 'BUY_HARDWARE',
  ORDER_BY_PROJECT = 'ORDER_BY_PROJECT',
  INVENTORY_MANAGEMENT = 'INVENTORY_MANAGEMENT',
  MANAGE_ORDERS = 'MANAGE_ORDERS',
  QUOTES = 'QUOTES',
}
